"use client";

import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { cn } from "@/core/shared/v2/lib/utils";
import type { InputWrapperWrap } from "../input/input-wrapper";
import { InputWrapper } from "../input/input-wrapper";

export interface SelectProps extends ComponentPropsWithRef<"select"> {
  wrap?: InputWrapperWrap;
  showCheckIcon?: boolean;
}

const SelectRoot = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, wrap = true, showCheckIcon = false, children, ...props }, ref) => {
    const selectStyles =
      "flex h-12 w-full rounded-md border border-stone-400 bg-background px-3 py-2 text-base text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:border-stone-400 disabled:opacity-50 disabled:select-none enabled:aria-invalid:border-destructive md:text-sm";

    const selectElement = (
      <select ref={ref} className={cn(selectStyles, className)} {...props}>
        {children}
      </select>
    );

    return wrap ? (
      <InputWrapper wrap={wrap} showCheckIcon={showCheckIcon}>
        {selectElement}
      </InputWrapper>
    ) : (
      selectElement
    );
  },
);

SelectRoot.displayName = "Select";

const Option = forwardRef<HTMLOptionElement, ComponentPropsWithRef<"option">>(({ children, ...props }, ref) => {
  return (
    <option ref={ref} {...props}>
      {children}
    </option>
  );
});

Option.displayName = "SelectOption";

export const Select = Object.assign(SelectRoot, { Option });
